function getProductLocationName({product, locationType}) {
    if(!locationType) return "No Location Type";
    if(!product) return `None`;
    if(!product.hasLocationType(locationType)) return `None`;
    return product.getLocationForType(locationType).name;
}
export  {
    getProductLocationName,
}